import { convertToTwoDecimelNumber, formatDate, getCookie, simulateAsyncOperation, throttle } from "mmbclient/Common/CommonFunctions";
import { getClientBalance } from "mmbclient/Common/CommonRazorPay";
import { checkSession, getAllClients } from "mmbclient/Common/CommonService";
import { AD, All, API_PATH, APP_TYPE_COOKIE_NAME, CONSIGNMENT_REPORT, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, MMB, MMB_LIVE, PAGE_LOADING_TIME, TRACKING_REPORT, US, USER_TYPE_COOKIE_NAME, WALLET } from "mmbclient/Common/CommonVariable";
import { RenderPagination } from "mmbclient/Components/RenderPagination";
import { useContext, useEffect, useRef, useState } from "react";
import * as XLSX from 'xlsx';

const ConsignmentDetail2Controller = (store) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [option, setOption] = useState('');
    const [status, setStatus] = useState('');
    const [client, setClient] = useState("All");
    const [clientOption, setClientOption] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemPerPage , setItemPerPage] = useState(20);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const wallet = useContext(WALLET);

    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    await Promise.all([
                        loadAllClients(store),
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                } else {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    async function loadAllClients(store) {

        const response = await getAllClients(store);
        let lst_Client = [];
        lst_Client.push("All");
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
        }
        setClientOption(lst_Client);
        setClient(lst_Client[0]);
    }


    const loggerFunc = () => {
        checkSession(store);
        getClientBalance(wallet);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleSearch = async (e) => {
        e.preventDefault();
        // Check if the end date is earlier than the start date
        if (endDate < startDate) {
            alert("End date cannot be earlier than start date.");
            return;
        }

        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        setLoading(true);

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
            let temp;
            if (option === 'Domestic') {
                temp = 'DO';
            } else if (option === 'International') {
                temp = 'IN';
            } else {
                temp = '';
            }
            let delStatus = '';
            if (status === 'Delivered') {
                delStatus = 'DEL';
            } else if (status === 'Undelivered') {
                delStatus = 'OTHER';
            }
            const Data = "Data";
            if (c.length === 4) {
                let query = {};
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    if (client === All) {
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": client, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10), "domInt": temp, "delStatus": delStatus };
                    } else {
                        const clientCode = client.split("|")[1].trim();
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10), "domInt": temp, "delStatus": delStatus };
                    }
                } else if (getCookie(USER_TYPE_COOKIE_NAME) === US) {
                    query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": c[1], "brnCode": c[3], "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10), "domInt": temp, "delStatus": delStatus };
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const path = API_PATH + CONSIGNMENT_REPORT + "getconsignment";
                // console.log(path);
                // console.log(query);
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                if (response.length > 0 && response !== "Result Not Found") {
                    setData(response);
                    console.log(response);
                } else {
                    setData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };


    const handlePrint = async(awb_no) => {
            
            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
    
            setLoading(true);
    
            try{
    
                const cookie = getCookie(LOGIN_COOKIE_NAME);
                const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    
                if(c.length === 4){
                    const userKey  = c[0];
                    const clientCode = c[1];
                    const userType = getCookie(APP_TYPE_COOKIE_NAME);
    
                    let value = "";
                    if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                       if(MMB_LIVE === userType){
                            value = "where db.awb_no = '" + awb_no  + "'";  
                        }else if(MMB === userType){
                            value = "where cb.awb_no = '" + awb_no  + "'";
                        }
                    }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                        if(MMB_LIVE === userType){
                            value = "where db.awb_no = '" + awb_no  + "' and  db.client_code = '" + clientCode + "'";  
                        }else if(MMB === userType){
                            value = "where cb.awb_no = '" + awb_no  + "' and cb.client_cd = '"  + clientCode + "'";
                        }
                    }
                    console.log(value);
    
                    const query = {"value":value, "userKey" : userKey, "userType" : userType};
    
                    const responseOption = {
                        method : "POST",
                        headers : {"Content-Type" : "application/json"},
                        body : new URLSearchParams({
                            query : JSON.stringify(query),
                            key : "checkService"
                        })
                    }
    
                    const path = API_PATH  + TRACKING_REPORT + "getprintshipper";
    
                    const response = await fetch(path, responseOption);
                    const contentType = response.headers.get("Content-Type");
    
                    if(contentType && contentType.includes('application/octet-stream')){
                        const arrayBuffer = await response.arrayBuffer();
                        const blob = new Blob([arrayBuffer], { type: 'application/pdf' })
                        const url = URL.createObjectURL(blob);
    
                        // Open PDF immediately
                        window.open(url, "_blank", "noopener,noreferrer,width=800,height=600");
                    }else{
                        const errText = await response.text();
                        alert(errText)
                    }
                }
            }catch(eror){
                console.log(eror);
            }finally{
                setLoading(false);
            }
    }


    const escapeCsvValue = (value) => {
        if (typeof value === 'string') {
            // Replace commas, newlines, and carriage returns with semicolons
            value = value.replace(/[,]/g, ';')    // Replace commas with semicolons
                .replace(/[\n]/g, ';')   // Replace newlines with semicolons
                .replace(/[\r]/g, ';');  // Replace carriage returns with semicolons
            // Optionally, escape double quotes by replacing them with two double quotes
            value = value.replace(/"/g, '""');
        }
        return value;
    };

    const exportToCSV = () => {
        const csvRows = [];

        let headers;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            headers = [
                'SNo',
                'Client',
                'Booking Date',
                'Awb No',
                'Fwd No/Ref No',
                'Origin',
                'Destination',
                'Pcs',
                'Network',
                'Type',
                'Weight',
                'Amount',
                'Sender',
                'Receiver',
                'Status',
                'Remarks'
            ];
        } else {
            headers = [
                'SNo',
                'Booking Date',
                'Awb No',
                'Fwd No/Ref No',
                'Origin',
                'Destination',
                'Pcs',
                'Network',
                'Type',
                'Weight',
                'Amount',
                'Sender',
                'Receiver',
                'Status',
                'Remarks'
            ];
        }

        csvRows.push(headers.join(',')); // Add headers

        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            data.forEach((item, index) => {
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(item.client_name || ''),
                    escapeCsvValue(formatDate(item.booking_date) || ''),
                    escapeCsvValue(item.awb_no || ''),
                    escapeCsvValue(item.forwarding_no || ''),
                    escapeCsvValue(item.origin_city || ''),
                    escapeCsvValue(item.city_name || ''),
                    escapeCsvValue(item.packets || ''),
                    escapeCsvValue(item.network || ''),
                    escapeCsvValue(item.document_type === 'D' ? 'Dox' : 'NDox' || ''),
                    escapeCsvValue(item.billing_weight || ''),
                    escapeCsvValue(convertToTwoDecimelNumber(item.taxable_amount) || ''),
                    escapeCsvValue(item.consignor_phone || ''),
                    escapeCsvValue(item.consignee_phone || ''),
                    escapeCsvValue(item.delivery_status || ''),
                    escapeCsvValue(item.remarks || '')
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        } else {
            data.forEach((item, index) => {
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(formatDate(item.booking_date) || ''),
                    escapeCsvValue(item.awb_no || ''),
                    escapeCsvValue(item.forwarding_no || ''),
                    escapeCsvValue(item.origin_city || ''),
                    escapeCsvValue(item.city_name || ''),
                    escapeCsvValue(item.packets || ''),
                    escapeCsvValue(item.network || ''),
                    escapeCsvValue(item.document_type || ''),
                    escapeCsvValue(item.billing_weight || ''),
                    escapeCsvValue(convertToTwoDecimelNumber(item.taxable_amount) || ''),
                    escapeCsvValue(item.consignor_phone || ''),
                    escapeCsvValue(item.consignee_phone || ''),
                    escapeCsvValue(item.delivery_status || ''),
                    escapeCsvValue(item.remarks || '')
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        }

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const exportToExcel = () => {
        if (Array.isArray(data) && data.length === 0) {
            alert("No data found");
            return;
        }

        setLoading(true);

        let ws;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                Client: item.client_name || '',
                'Booking Date': formatDate(item.booking_date) || '',
                'Awb No': item.awb_no || '',
                'Fwd No/Ref No': item.forwarding_no || '',
                Origin: item.origin_city || '',
                Destination: item.city_name || '',
                Pcs: item.packets || '',
                Network: item.network || '',
                Type: item.document_type === 'D' ? 'Dox' : 'NDox' || '',
                Weight: item.billing_weight || '',
                Amount: convertToTwoDecimelNumber(item.taxable_amount) || '',
                Sender: item.consignor_phone || '',
                Receiver: item.consignee_phone || '',
                Status: item.delivery_status || '',
                Remarks: item.remarks || ''
            })));
        } else {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                'Booking Date': formatDate(item.booking_date) || '',
                'Awb No': item.awb_no || '',
                'Fwd No/Ref No': item.forwarding_no || '',
                Origin: item.origin_city || '',
                Destination: item.city_name || '',
                Pcs: item.packets || '',
                Network: item.network || '',
                Type: item.document_type === 'D' ? 'Dox' : 'NDox' || '',
                Weight: item.billing_weight || '',
                Amount: convertToTwoDecimelNumber(item.taxable_amount) || '',
                Sender: item.consignor_phone || '',
                Receiver: item.consignee_phone || '',
                Status: item.delivery_status || '',
                Remarks: item.remarks || ''
            })));
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');

        XLSX.writeFile(wb, 'Data.xlsx');
        setLoading(false);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
     const itemsPerPage = itemPerPage;

    // Filter data based on search term
    const filteredData = data.filter(item => {

        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        return (
            String(item?.client_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.booking_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.forwarding_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.origin_city)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.city_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.packets)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.network)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.billing_weight)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.consignor_phone)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.consignee_phone)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.delivery_status)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.remarks)?.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }
    );

    // Calculate total pages
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const handleEnterAsTab = (e) => {
    // Skip if dropdown/autocomplete is active
    if (
        e.key === "Enter" &&
        e.target.tagName !== "TEXTAREA"
    ) {
        e.preventDefault();

        const form = e.target.form;
        const elements = Array.from(form.elements);
        const index = elements.indexOf(e.target);

        if(elements[index].name === 'saveBtn'){
            handleSearch(e);
            console.log(elements[index].name)
            elements[0].focus();
            return;
        }
        else if(elements[index].name==='startDate'){
            startDateRef.current.setOpen(false);
        }else if(elements[index].name==='endDate'){
            endDateRef.current.setOpen(false);
        }
        
        for (let i = index + 1; i < elements.length; i++) {
            if (
                elements[i].focus &&
                !elements[i].disabled &&
                elements[i].type !== "hidden"
            ) {
                elements[i].focus();
                break;
            }
        }
    }
};

const handlePrintPOD= (podPath)=>{
    console.log(podPath);
    const podUrl = "http://mmblive.in" + podPath;

    // Open PDF immediately
    window.open(podUrl, "_blank", "noopener,noreferrer,width=600,height=400");

}

    return { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, status, setStatus, betterLoggerFunction, handleSearch,handlePrint, exportToCSV, exportToExcel, RenderPagination , setItemPerPage,handleEnterAsTab,startDateRef,endDateRef, handlePrintPOD}
}

export default ConsignmentDetail2Controller;